import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Table, TableHead, TableBody, TextField } from '@mui/material';
import { formatDate } from '../../constant';

const AdminInventoryDetail = ({ open, setOpen, data }) => {
    const [simMobileNo, setSimMobileNo] = useState(data?.productId);
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setSimMobileNo(data?.productId);
    }, [data?.productId]);

    const styles = {
        modalBox: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 550,
            height: '70vh',
            border: 'none',
            bgcolor: 'white',
            borderRadius: '10px',
            boxShadow: 12,
            textAlign: 'center',
            overflow: 'auto'
        },
        heading: {
            fontWeight: 600,
            fontSize: 27,
            marginBottom: '10px',
        },
        row: {
            display: 'flex',
            width: '100%',
            gap: '10px',
            margin: '4% 0',
            fontWeight: 400,
            fontSize: 16,
        },
        dataLabel: {
            fontWeight: 400,
            fontSize: 16,
            width: '50%',
            textAlign: 'left'
        },
        dataValue: {
            fontWeight: 400,
            fontSize: 16,
            marginLeft: 'auto',
            width: '50%',
            textAlign: 'right'
        },
        icon: {
            width: 22,
        },
        headingTypography: {
            fontWeight: 500,
            fontSize: 22,
            marginBottom: '10px',
            textAlign: 'left',
            p: 3,
            borderBottom: '1px solid gainsboro'
        }
    };

    const shippingAddress = data?.shippingAddress
        ? `${data.shippingAddress.street}, ${data.shippingAddress.city}, ${data.shippingAddress.zipCode}, ${data.shippingAddress.state}`
        : '-';

    const DataRow = ({ label, value }) => (
        <div style={styles.row}>
            <span style={styles.dataLabel}>{label}</span>
            <span style={styles.dataValue}>{value}</span>
        </div>
    );


    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box sx={styles.modalBox}>
                <Typography id="logout-modal-title" variant="h6" sx={styles.headingTypography}>
                    Gps Details
                </Typography>
                <Box sx={{ padding: '2% 6% 6% 6%' }}>

                    <DataRow label="Company Name" value={data?.clientId?.companyName || '-'} />
                    <DataRow label="Company Email" value={data?.clientId?.email || '-'} />
                    <DataRow label="Contact Number" value={data?.clientId?.contactNo || '-'} />
                    <DataRow label="IMEI NO" value={data?.imeiNumber || '-'} />
                    <DataRow label="SIM NO" value={data?.simNumber|| '-'} />
                    <DataRow label="Device Unique ID" value={data?.deviceUniqueId || '-'} />
                    <DataRow label="Gps Status" value={data?.gpsStatus || '-'} />
                    <DataRow label="Gps Install Date" value={data?.dateOfInstall && formatDate(data?.dateOfInstall) || '-'} />
                </Box >
            </Box >
        </Modal >
    );
};

export default AdminInventoryDetail;
